import api from './api';

// Everything the applicant does about their own application(s).
const applicantService = {
  myApplications: async () => (await api.get('/applicant/applications')).data,

  getProfile: async (applicationId) => (await api.get(`/applicant/profile/${applicationId}`)).data,
  saveProfile: async (applicationId, data) => (await api.put(`/applicant/profile/${applicationId}`, data)).data,
  submit: async (applicationId) => (await api.post(`/applicant/submit/${applicationId}`)).data,

  timeline: async (applicationId) => (await api.get(`/applications/${applicationId}/timeline`)).data,

  grantConsent: async (applicationId, consents) =>
    (await api.post(`/applications/${applicationId}/consent`, { notice_version: '1', consents })).data,
  consentHistory: async () => (await api.get('/me/consents')).data,
  withdrawConsent: async (recordId, reason) => (await api.post(`/consent/${recordId}/withdraw`, { reason })).data,

  listDocuments: async (applicationId) => (await api.get(`/applications/${applicationId}/documents`)).data,
  uploadDocument: async (applicationId, file, documentType, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    form.append('document_type', documentType);
    return (
      await api.post(`/applications/${applicationId}/documents`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
        }
      })
    ).data;
  },
  deleteDocument: async (documentId) => (await api.delete(`/documents/${documentId}`)).data,
  documentBlob: async (documentId) => (await api.get(`/documents/${documentId}/download`, { responseType: 'blob' })).data,

  decisions: async (applicationId) => (await api.get(`/applications/${applicationId}/decisions`)).data,
  raiseDispute: async (applicationId, data) => (await api.post(`/applications/${applicationId}/dispute`, data)).data,

  requestDeletion: async (applicationId, reason) =>
    (await api.post(`/applications/${applicationId}/deletion`, { request_type: 'deletion', reason })).data,

  // Downloads a JSON copy of everything held about the user.
  exportData: async () => (await api.get('/me/data-export', { responseType: 'blob' })).data
};

export default applicantService;
